import React from 'react';
import { Card, Btn, Divider, Stepper, Header, BottomNav } from '../components/SharedComponents';
import C from '../styles/tokens';

const PaymentVerification = ({ navigate }) => (
  <div className="page-wrapper slide-up">
    <Header title="Order Status" onBack={() => navigate('buy')} />

    <div className="page-content-lg">

      {/* Icon + Title */}
      <div className="text-center mb-24">
        <div
          className="success-icon-wrap success-icon-wrap-yellow pulse"
          style={{ margin: '0 auto 14px' }}
        >
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
            stroke={C.warning} strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
        </div>
        <h2 style={{ fontWeight: 900, fontSize: 22, color: C.textPrimary }}>
          Payment Under Verification
        </h2>
        <p style={{ color: C.textSecondary, fontSize: 14, marginTop: 6, lineHeight: 1.5 }}>
          We are verifying your payment manually. Funds will be credited shortly after confirmation.
        </p>
      </div>

      {/* Order Details */}
      <Card style={{ marginBottom: 16 }}>
        {[
          { label: 'Order ID',        val: 'XD73826A9F01', mono: true },
          { label: 'Amount Paid',     val: '₹900' },
          { label: 'You Will Receive',val: '10 USDT', valColor: C.accent },
          { label: 'Submitted At',    val: 'Today, 11:45 AM' },
        ].map((row, i) => (
          <div key={i}>
            {i > 0 && <Divider />}
            <div className="flex justify-between items-center" style={{ padding: '10px 0' }}>
              <span style={{ fontSize: 13, color: C.textMuted }}>{row.label}</span>
              <span style={{
                fontWeight: 700, fontSize: 14,
                color: row.valColor || C.textPrimary,
                fontFamily: row.mono ? 'Space Mono, monospace' : 'Nunito, sans-serif',
              }}>
                {row.val}
              </span>
            </div>
          </div>
        ))}
      </Card>

      {/* Status Stepper */}
      <Card style={{ marginBottom: 20 }}>
        <Stepper steps={[
          { label: 'Order Created',                  status: 'done',   time: 'Today, 11:45 AM' },
          { label: 'Payment Screenshot Uploaded',    status: 'done',   time: 'Today, 11:45 AM' },
          { label: 'Awaiting Verification',          status: 'active', time: 'In progress...' },
          { label: 'Funds Credited',                 status: 'pending' },
        ]} />
      </Card>

      {/* Actions */}
      <Btn onClick={() => navigate('buyOrderStatus')} variant="primary" full size="lg">
        View Order Status
      </Btn>
      <Btn
        onClick={() => navigate('dashboard')}
        variant="ghost" full size="md"
        style={{ marginTop: 10 }}
      >
        Back to Dashboard
      </Btn>
    </div>

    <BottomNav active="buy" navigate={navigate} />
  </div>
);

export default PaymentVerification;
